import React from "react";
import { Skeleton } from "@mui/material";

export const BoxSkeleton = () => {
	return (
		<Skeleton
			animation="wave"
			variant="rectangular"
			sx={{
				width: "100%",
				maxWidth: "25em",
				height: "auto",
				minHeight: "18.25em",
				borderRadius: "1.5em",
				"@media (orientation: landscape)": {
					//width: "14.1875em",
					height: "24.9375em"
				}
			}}
		/>
	);
};
